import camelcaseKeys from 'camelcase-keys';
const transformPaymentResponse = (response, meta, arg) => {
    var _a;
    const payment = (_a = response === null || response === void 0 ? void 0 : response.PaymentOptions) === null || _a === void 0 ? void 0 : _a[0];
    if (!payment)
        return { transformedData: undefined, originalResponse: response };
    const payloadBody = arg === null || arg === void 0 ? void 0 : arg.body;
    const detKeys = {
        modelKey: payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.modelKey,
        modelYear: payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.modelYear,
        trimKey: payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.trimKey,
        transmissionKey: payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.transmissionKey,
        exteriorColorKey: payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.exteriorColorKey,
        interiorColorKey: payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.interiorColorKey,
    };
    const levies = payment.Levies ? camelcaseKeys(payment.Levies) : [];
    const leaseKilometers = payment.LeaseKilometers ? camelcaseKeys(payment.LeaseKilometers) : [];
    const offerPeriod = payment.OfferPeriod ? camelcaseKeys(payment.OfferPeriod) : {};
    const accessories = payment.Accessories ? camelcaseKeys(payment.Accessories) : [];
    const exteriorColors = payment.ExteriorColours ? camelcaseKeys(payment.ExteriorColours, { deep: true }) : [];
    const protections = payment.OwnerPrograms ? camelcaseKeys(payment.OwnerPrograms) : [];
    const warranties = payment.Warranties ? camelcaseKeys(payment.Warranties) : [];
    const transformedData = {
        detKeys,
        accessories,
        apr: payment.Apr || 0,
        downPaymentAmount: payment.DownPaymentAmount || 0,
        estimatedBalance: payment.EstimatedBalance || 0,
        exteriorColors,
        freightAndPdi: payment.FreightAndPdi || 0,
        totalCostOfBorrowing: payment.TotalCostOfBorrowing || 0,
        ppsaRegistrationAndAgentFee: payment.PpsaRegistrationAndAgentFee || 0,
        leviesAndFeesTotal: payment.LeviesAndFeesTotal || 0,
        informationalApr: payment.InformationalApr || null,
        isSellingPriceProvince: response === null || response === void 0 ? void 0 : response.IsSellingPriceProvince,
        leaseAdditionalAnnualKm: payment.LeaseAdditionalAnnualKm || 0,
        leaseAnnualKmAllowance: payment.LeaseAnnualKmAllowance || 0,
        leaseKilometers,
        levies,
        msrp: {
            value: payment.Msrp || 0,
            label: '',
        },
        netPaymentAmount: payment.NetPaymentAmount || 0,
        numberOfTotalPayments: payment.NumberOfTotalPayments || 0,
        offerPeriod,
        paymentFrequency: payment.PaymentFrequency
            ? payment.PaymentFrequency.toLowerCase()
            : undefined,
        paymentMethod: payment.PaymentMethod ? payment.PaymentMethod.toLowerCase() : undefined,
        preferredPaymentAmount: payment.PreferredPaymentAmount || 0,
        protections,
        sellingPrice: {
            value: payment.EstimatedBalance || 0,
            label: '',
        },
        ruleExceptions: camelcaseKeys(payment.RuleExceptions) || [],
        taxes: payment.PaymentTaxes || 0,
        term: payment.Term || 0,
        terms: camelcaseKeys(payment.Terms) || [],
        tradeInOwingAmount: payment.TradeInOwingAmount || 0,
        tradeInValueAmount: payment.TradeInValueAmount || 0,
        warranties: warranties.map(w => ({
            ...w,
            businessKey: w.key,
        })),
        warrantyAmount: (payment === null || payment === void 0 ? void 0 : payment.WarrantyAmount) || 0,
    };
    return { transformedData, originalResponse: response };
};
export const transformMultiplePaymentsResponse = (response, meta, arg) => response.map((r, i) => {
    const payloadBody = arg.body[i];
    return payloadBody
        ? transformPaymentResponse(r, meta, {
            url: arg.url,
            body: payloadBody,
            languageCode: '',
        }).transformedData
        : undefined;
});
export default transformPaymentResponse;
